import React from 'react';
import MediumTypography from '../../../components/formlib/MediumTypography';
import { Box } from '@mui/system';

const IfspBlankTabScreen = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#E7F0F0',
        padding: '32px 32px 32px 32px',
        height: '464px',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#ECF9F8',
          borderWidth: '1px',
          borderRadius: '2px',
          borderColor: '#00C6B8',
          borderStyle: 'solid',
          height: '100%',
        }}
        className="flex__ justifyContent-Center align__items__center cursorPointer"
        onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <MediumTypography
          labelid="IFSP.BlankTabMsgText"
          defaultlabel="The Outcomes, Service Delivery, and Transition sections will become accessible only after a Meeting Date has been added to the IFSP."
          fontSize="16px"
          fontweight={600}
        />
      </Box>
    </Box>
  );
};

export default IfspBlankTabScreen;
